import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Replay30Icon(props: IconProps) {
    return <Icon {...props} iconKey={"replay_30"}/>
}
